// Homepage banner slider (sections/joy-hero.liquid, two or more active banners): the slides scroll sideways (swipe on
// phones, scroll-snap), the dots jump to a slide and follow the scroll, and every 6 s the next slide comes in (after
// the last, the first). The timer waits while the pointer is over the banner, while it has keyboard focus and while
// the tab is hidden, stops with the pause button beside the dots, starts again after a swipe or a dot, and never runs
// with reduced motion (the pause button is hidden then).
(() => {
  const root = document.querySelector('[data-hero-slider]');
  const track = root?.querySelector('[data-hero-track]');
  const slides = track ? [...track.children] : [];
  if (slides.length < 2) return;
  const dots = [...root.querySelectorAll('[data-hero-dot]')];
  const pauseButton = root.querySelector('[data-hero-pause]');
  const still = window.matchMedia('(prefers-reduced-motion: reduce)');
  const DELAY = 6000;
  let index = 0;
  let timer;
  let hovered = root.matches(':hover');
  let focused = false;
  let paused = false;

  const show = (next, smooth = true) => {
    index = (next + slides.length) % slides.length;
    track.scrollTo({ left: index * track.clientWidth, behavior: smooth && !still.matches ? 'smooth' : 'auto' });
  };
  const restart = () => {
    clearInterval(timer);
    if (pauseButton) pauseButton.hidden = still.matches;
    if (still.matches || paused) return;
    timer = setInterval(() => {
      if (!hovered && !focused && !document.hidden) show(index + 1);
    }, DELAY);
  };

  // The dots follow the scroll position once it settles (a timeout, not an animation frame, so it also runs
  // while the tab is in the background).
  let settle;
  track.addEventListener('scroll', () => {
    clearTimeout(settle);
    settle = setTimeout(() => {
      index = Math.round(track.scrollLeft / track.clientWidth);
      dots.forEach((dot, n) => dot.setAttribute('aria-current', String(n === index)));
    }, 60);
  }, { passive: true });
  dots.forEach((dot, n) => dot.addEventListener('click', () => { show(n); restart(); }));
  pauseButton?.addEventListener('click', () => {
    paused = !paused;
    pauseButton.toggleAttribute('data-paused', paused);
    pauseButton.setAttribute('aria-label', paused ? pauseButton.dataset.labelPlay : pauseButton.dataset.labelPause);
    restart();
  });
  root.addEventListener('pointerenter', (event) => { if (event.pointerType === 'mouse') hovered = true; });
  root.addEventListener('pointerleave', () => { hovered = false; });
  // The pause button is part of the slider: focusing it must not count as "reading a slide".
  root.addEventListener('focusin', (event) => { focused = event.target !== pauseButton; });
  root.addEventListener('focusout', () => { focused = false; });
  track.addEventListener('touchend', restart, { passive: true });
  window.addEventListener('resize', () => show(index, false));
  still.addEventListener?.('change', restart);
  restart();
})();
